
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';  
import LoginScreen from "./component/login";  
import SingupScreen from "./component/signup";  
import SingupFillUserInfo from "./component/filluserinfo";  
import Userforgot from "./component/userforgot";  
import ForgotPassword from "./component/forgotpwd";  
import ResetPwd from "./component/resetpwd";  
import BMIScreen from "./component/BMI_Step/mainstep"; 
import AdminLoginScreen from "./component/admin/login";  
import AdminDashboard from "./component/admin/dashboard";
import AllPatients from "./component/admin/allPatients";
import SearchFilter from "./component/admin/searchfilter";  
import ViewPatientProfile from "./component/admin/viewpatient";  
import AdminUser from "./component/admin/adminUser";  
import AdminUserinfo from "./component/admin/adminUserinfo";  
import AddAdminUser from "./component/admin/addAdminUser";  
import Adminforgot from "./component/admin/adminforgot";
import AdminForgotPassword from "./component/admin/adminForgotPwd";
import AdminResetPwd from "./component/admin/adminResetPwd";
import UserProfile from "./component/userprofile"; 
import ChatBot from "./component/chatbot"; 
import "./assest/css/style.css"; 
import { ToastContainer, toast } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css";
import { SearchProvider  } from '../src/component/admin/SearchContext';
import InsuranceAddInfo from "./component/insuranceinfo";
import UserMyInsurance from "./component/myinsurance";
import PatientDashboard from "./component/dashboard";
import ProcedureData from "./component/BMI_Step/proceduredata";
import ViewDocuments from "./component/admin/viewdocs";
import ConsentNotice from "./component/consenttext";
import NPIRegistry from "./component/autosuggest";
import PatientHistory from "./component/patienthistory";
import DashboardView from "./component/dashboardView";
import ViewFullReport from "./component/admin/viewFullHistory";
import ZoomCallLink from "./component/admin/zoomcall";
import AdminSettings from "./component/admin/settings";
import PortalUsers from "./component/admin/portalUsers";
import PCPCases from "./component/admin/pcpCases";
import AdminProtectedRoute from "./component/admin/AdminProtectedRoute";
import PatientProtectedRoute from "./component/PatientProtectedRoute";
import AISummaryTemplate from "./component/aiSummaryTemplate";
import { ROLES } from "./services/firestore";
import DomainRedirect from "./component/DomainRedirect";
import SessionTimeoutProvider from "./component/SessionTimeoutProvider";
import { ADMIN_DOMAIN } from "./config/domains";

const isAdminDomain = window.location.hostname === ADMIN_DOMAIN;

function App() {
  return (
    <div className="App">
    <ToastContainer/>
      <Router>
    <SessionTimeoutProvider>
    <DomainRedirect />
    <SearchProvider>
          <Routes>
            <Route path="/" element={isAdminDomain ? <AdminLoginScreen /> : <LoginScreen />} />       
            <Route path="/signup" element={<SingupScreen />} />  
            <Route path="/filluserinfo" element={<PatientProtectedRoute><SingupFillUserInfo /></PatientProtectedRoute>} />
            <Route path="/addinsuranceinfo" element={<PatientProtectedRoute><InsuranceAddInfo /></PatientProtectedRoute>} />
            <Route path="/newappointment" element={<PatientProtectedRoute><BMIScreen /></PatientProtectedRoute>} />
            <Route path="/zoomcalllink" element={<PatientProtectedRoute><ZoomCallLink /></PatientProtectedRoute>} />
            {!isAdminDomain && <Route path="/dashboard" element={<PatientProtectedRoute><PatientDashboard /></PatientProtectedRoute>} />}
            <Route path="/dashboardview" element={<PatientProtectedRoute><DashboardView /></PatientProtectedRoute>} />
            <Route path="/patienthistory/:sessionIDNew" element={<PatientProtectedRoute><PatientHistory /></PatientProtectedRoute>} />

            <Route path="/chatbot" element={<PatientProtectedRoute><ChatBot /></PatientProtectedRoute>} />
            <Route path="/userprofile" element={<PatientProtectedRoute><UserProfile /></PatientProtectedRoute>} />
            <Route path="/myinsurance" element={<PatientProtectedRoute><UserMyInsurance /></PatientProtectedRoute>} />
            <Route path="/aisummarytemplate" element={<PatientProtectedRoute><AISummaryTemplate /></PatientProtectedRoute>} />
            {!isAdminDomain && <Route path="/changepassword" element={<PatientProtectedRoute><Userforgot /></PatientProtectedRoute>} />} 
            <Route path="/reset_password" element={isAdminDomain ? <AdminResetPwd /> : <ResetPwd />} />
            <Route path="/forgotpassword" element={isAdminDomain ? <AdminForgotPassword /> : <ForgotPassword />} />  
            <Route path="/admin" element={<AdminLoginScreen />} />
            <Route path="/admin/allpatients" element={<AdminProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.MA]}><AllPatients /></AdminProtectedRoute>} />
            <Route path="/admin/dashboard" element={<AdminProtectedRoute><AdminDashboard /></AdminProtectedRoute>} />
            <Route path="/admin/patientprofile" element={<AdminProtectedRoute><ViewPatientProfile /></AdminProtectedRoute>} />
            <Route path="/admin/adminusers" element={<AdminProtectedRoute allowedRoles={[ROLES.ADMIN]}><AdminUser /></AdminProtectedRoute>} />
            <Route path="/admin/adminusersinfo" element={<AdminProtectedRoute allowedRoles={[ROLES.ADMIN]}><AdminUserinfo /></AdminProtectedRoute>} />
            <Route path="/admin/adduseradmin" element={<AdminProtectedRoute allowedRoles={[ROLES.ADMIN]}><AddAdminUser /></AdminProtectedRoute>} />
            <Route path="/admin/myprofile" element={<AdminProtectedRoute><AdminUserinfo /></AdminProtectedRoute>} />
            <Route path="/admin/changepassword" element={<AdminProtectedRoute><Adminforgot /></AdminProtectedRoute>} />
            <Route path="/admin/searchresult" element={<AdminProtectedRoute><SearchFilter /></AdminProtectedRoute>} />
            <Route path="/autosuggestion" element={<ProcedureData />} />
            <Route path="/admin/viewdocuments" element={<AdminProtectedRoute><ViewDocuments /></AdminProtectedRoute>} />
            <Route path="/admin/settings" element={<AdminProtectedRoute allowedRoles={[ROLES.ADMIN]}><AdminSettings /></AdminProtectedRoute>} />
            <Route path="/admin/portalusers" element={<AdminProtectedRoute allowedRoles={[ROLES.ADMIN]}><PortalUsers /></AdminProtectedRoute>} />
            <Route path="/admin/fullreport" element={<AdminProtectedRoute><ViewFullReport /></AdminProtectedRoute>} />
            <Route path="/admin/pcp-cases" element={<AdminProtectedRoute allowedRoles={[ROLES.MA]}><PCPCases /></AdminProtectedRoute>} />

            {/* Clean admin routes without /admin prefix (admin subdomain only) */}
            {isAdminDomain && (<>
              <Route path="/allpatients" element={<AdminProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.MA]}><AllPatients /></AdminProtectedRoute>} />
              <Route path="/dashboard" element={<AdminProtectedRoute><AdminDashboard /></AdminProtectedRoute>} />
              <Route path="/patientprofile" element={<AdminProtectedRoute><ViewPatientProfile /></AdminProtectedRoute>} />
              <Route path="/adminusers" element={<AdminProtectedRoute allowedRoles={[ROLES.ADMIN]}><AdminUser /></AdminProtectedRoute>} />
              <Route path="/adminusersinfo" element={<AdminProtectedRoute allowedRoles={[ROLES.ADMIN]}><AdminUserinfo /></AdminProtectedRoute>} />
              <Route path="/adduseradmin" element={<AdminProtectedRoute allowedRoles={[ROLES.ADMIN]}><AddAdminUser /></AdminProtectedRoute>} />
              <Route path="/myprofile" element={<AdminProtectedRoute><AdminUserinfo /></AdminProtectedRoute>} />
              <Route path="/changepassword" element={<AdminProtectedRoute><Adminforgot /></AdminProtectedRoute>} />
              <Route path="/searchresult" element={<AdminProtectedRoute><SearchFilter /></AdminProtectedRoute>} />
              <Route path="/viewdocuments" element={<AdminProtectedRoute><ViewDocuments /></AdminProtectedRoute>} />
              <Route path="/settings" element={<AdminProtectedRoute allowedRoles={[ROLES.ADMIN]}><AdminSettings /></AdminProtectedRoute>} />
              <Route path="/portalusers" element={<AdminProtectedRoute allowedRoles={[ROLES.ADMIN]}><PortalUsers /></AdminProtectedRoute>} />
              <Route path="/fullreport" element={<AdminProtectedRoute><ViewFullReport /></AdminProtectedRoute>} />
              <Route path="/pcp-cases" element={<AdminProtectedRoute allowedRoles={[ROLES.MA]}><PCPCases /></AdminProtectedRoute>} />
            </>)}

            <Route path="/termcondition" element={<ConsentNotice />} />
            <Route path="/NPIRegistry" element={<NPIRegistry />} />
            <Route path="/admin/forgotpassword" element={<AdminForgotPassword />} />
            <Route path="/admin/reset_password" element={<AdminResetPwd />} />
            <Route path="/admin/*" element={<Navigate to={isAdminDomain ? "/" : "/admin"} replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />

         </Routes>
    </SearchProvider>
    </SessionTimeoutProvider>
    </Router> 
    </div>
  );
}

export default App;